window.Products.HomeDecor.HolidayStocking = function() {};
window.Products.HomeDecor.HolidayStocking.inherits(window.Products.HomeDecor.HomeDecor);
window.Products.HomeDecor.HolidayStocking.id = 99;
window.Products.HomeDecor.HolidayStocking.slug = 'holiday-stocking';
window.Products.HomeDecor.HolidayStocking.has_3d = true;
window.Products.HomeDecor.HolidayStocking.use_glb = true;
window.Products.HomeDecor.HolidayStocking.dpi = 150;

window.Products.HomeDecor.HolidayStocking.prototype.set3dProperties = function(modelViewer) {
	var me = this;

	modelViewer.setFixedView('front');

    modelViewer.object.position.x = -0.04;
    modelViewer.object.position.y = -0.3;

	if(!modelViewer.inlab) {
		modelViewer.object.scale.x = 1.7;
		modelViewer.object.scale.y = 1.7;
		modelViewer.object.scale.z = 1.7;
		modelViewer.object.position.y = -0.6;
	}
    
	me.loadEnvMap(function(){
		for(var i = 0; i < modelViewer.object.children[0].children.length; i++){
			if(!modelViewer.object.children[0].children[i].material) continue;
			modelViewer.object.children[0].children[i].material.aoMapIntensity = 1;
			modelViewer.object.children[0].children[i].material.envMap = me.envMap;
			modelViewer.object.children[0].children[i].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
			modelViewer.object.children[0].children[i].material.needsUpdate = true;
			modelViewer.object.children[0].children[i].material.envMap.needsUpdate = true;
		}

		modelViewer.object.children[0].children[1].material.opacity = 0.95;
		modelViewer.object.children[0].children[1].material.transparent= true;

        modelViewer.object.children[0].children[0].material.aoMapIntensity = 0.8;
        modelViewer.object.children[0].children[1].material.aoMapIntensity = 0.8;

		me.updateThreeTexture(modelViewer);
	});
};

window.Products.HomeDecor.HolidayStocking.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.8;
	controls.maxDistance = 4;
};

window.Products.HomeDecor.HolidayStocking.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.texture.flipY = false;
	modelViewer.object.children[0].children[0].material.map = modelViewer.texture;
	modelViewer.object.children[0].children[0].material.needsUpdate = true;
};

window.Products.HomeDecor.HolidayStocking.prototype.getEditableOptions = function(){
	return ["loop-color"];
};

window.Products.HomeDecor.HolidayStocking.prototype.getEditableOptionsNames = function(){
	return [__("create_ns_option.loop-color")];
};

window.Products.HomeDecor.HolidayStocking.prototype.getOptions = function(){
	var editableOptions = this.getEditableOptions();
	var options = this.static.options;
	if(!options) return;

	var out = [];

	for(var option_type_slug in options){
		if(editableOptions.indexOf(option_type_slug) == -1) continue;
		out[option_type_slug] = $('#container_options_'+option_type_slug).find('input:checked').val();
	}

	return out;
};

window.Products.HomeDecor.HolidayStocking.prototype.handleOption = function(modelViewer, option, value){
	switch(option){
		case 'loop-color':
			this.handleLoopColorOption(modelViewer, value);
			break;
	}
};

window.Products.HomeDecor.HolidayStocking.prototype.handleLoopColorOption = function(modelViewer, color) {
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_loop-color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_loop-color, #button_options_loop-color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-loop-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = this.getColor(color);
	var three_intensity = color == "white" ? 0.5 : 1;

	object.children[1].material.color = new THREE.Color(three_color);
    object.children[1].material.aoMapIntensity = three_intensity;
};

window.Products.HomeDecor.HolidayStocking.prototype.getColor = function(_name){
	colors = {
		"black": 0x080808,
		"white": 0xffffff,
	};

	return new THREE.Color(colors[_name]);
};